import { createContext, useContext } from "react";

const ConversationContext = createContext({});

export const ConversationContextProvider = ConversationContext.Provider;
export const ConversationContextConsumer = ConversationContext.Consumer;

export const useConversationContext = () => useContext(ConversationContext);

export default ConversationContext;
